export enum ActionConstant {
	GET_STATUS = 'FILE://USER/GET_STATUS',
	GET_USER_DETAILS = 'FILE://USER/GET_USER_DETAILS',
	CLEAR_STATUS = 'FILE://USER/CLEAR_STATUS',
	CLEAR_USER_DETAILS = 'FILE://USER/CLEAR_USER_DETAILS',
}
export interface Details {
	id: number;
	role: string;
	token: string;
	refreshToken: string;
	subscriptionStatus: string;
	tradeCreation: string;
	restrictProjectCreationToAdmins: string;
}
export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}
export interface GetUserDetailsType {
	type: ActionConstant.GET_USER_DETAILS;
	data: Details;
}

export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}
export interface ClearUserDetailsType {
	type: ActionConstant.CLEAR_USER_DETAILS;
}
export type ActionType =
	| GetStatusType
	| ClearStatusType
	| GetUserDetailsType
	| ClearUserDetailsType;

export interface InitialState {
	statusCode: number;
	userdetails: Details;
}
